import Vue from 'vue';
import BuddyPage from '@/components/pages/buddy/index.vue';
export default Vue.extend({
    name: 'BuddyView',
    components: {
        BuddyPage
    }
});
